import { useAppSelector } from '../../redux/store';
import { welcome } from '../../utils/kiosk-messages';
import SignInCta from '../sign-in-cta/sign-in-cta.component';

export const Login = () => {
    const navigationState = useAppSelector((store) => store.navigation);
    const display = navigationState.iot?.display;

    return (
        <div className='flex h-full flex-col items-center justify-center gap-36 self-stretch'>
            <div className='text-background-surface justify-start self-stretch text-center text-3xl font-semibold'>
                {display ? (
                    <div className='flex flex-col'>
                        <span>{welcome()}</span>
                        <span>{display}</span>
                    </div>
                ) : (
                    <div
                        role='status'
                        className='max-w-lg animate-pulse space-y-2.5'>
                        <div className='flex w-full items-center gap-2'>
                            <div className='bg-border-default h-2.5 w-32 rounded-full'></div>
                            <div className='bg-border-default h-2.5 w-24 rounded-full'></div>
                            <div className='bg-border-default h-2.5 w-full rounded-full'></div>
                        </div>
                    </div>
                )}
            </div>
            <SignInCta iconSize='small' />
        </div>
    );
};
